// TemplatePreview.tsx

import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { PropertyList } from '../AddTemplate/AddTemplate'; // If this is reusable/exported
import { getTranslation, filterHiddenProperties } from '@center-platform/spheres/identity';
import './TemplatePreview.scss';
interface TemplatePreviewProps {
  schema: any;
  matchedUseCases: any[];
  i18n: any;
  t: any;
  onClose: () => void;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  schema,
  matchedUseCases,
  i18n,
  t,
  onClose,
}) => {
  const label = getTranslation(i18n, schema.localization_name_key, schema.name);
  const desc = getTranslation(
    i18n,
    schema.localization_description_key,
    schema.schema_description_default
  );

  return (
    <div className="template-preview-slide-in">
      <div className="template-preview-header">
        <i className={schema.avatar ?? 'center-organization-icon'}></i>
        <h3>{label}</h3>
        <Button
          icon="pi pi-times"
          className="p-button-rounded p-button-text preview-close-btn"
          onClick={onClose}
          style={{ float: 'right' }}
        />
      </div>
      <div className="template-preview-body">
        <h4 className="pb-1 pt-2 m-0">
          {t('addTemplate.Overview', { defaultValue: 'Overview' })}
        </h4>
        <span className="sub-header">
          <i className="center-organization-icon"></i>
          <h5>Center Technologies</h5>
        </span>
        <p className={desc ? '' : 'template-preview-no-desc'}>
          {desc || t('addTemplate.noDescription', { defaultValue: 'No description available.' })}
        </p>
        {matchedUseCases.length > 0 && (
          <div className="use-case-content">
            <span className="use-case-label font-semibold mt-1">
              {t('addTemplate.usecases', { defaultValue: 'Use Cases:' })}
            </span>
            {matchedUseCases.map((uc) => (
              <Tag
                key={uc.system_name || uc.id}
                value={getTranslation(i18n, uc.localization_name_key, uc.name)}
                rounded
              />
            ))}
          </div>
        )}
        <div className="flow">
          <span className="font-semibold">
            {t('addTemplate.Arc', { defaultValue: 'Arc:' })}
          </span>
          <p className="mt-0">
            {schema.schema_flow ??
              t('addTemplate.Noarcinformation', {
                defaultValue: 'No arc information available.',
              })}
          </p>
        </div>
        <div className="flex">
          <PropertyList properties={filterHiddenProperties(schema.properties || [])} i18n={i18n} />
          {Array.isArray(schema.perspectives) &&
            schema.perspectives.some((p: any) => !p.is_hidden) && (
              <div className="perspectives-section">
                <h4 className="mb-1 mt-1">
                  {t('addTemplate.Perspectives', {
                    defaultValue: 'Perspectives',
                  })}
                </h4>
                {schema.perspectives.filter((p: any) => !p.is_hidden).map((persp: any) => {
                  const label = getTranslation(
                    i18n,
                    persp.label_key,
                    persp.name
                  );
                  const desc = getTranslation(
                    i18n,
                    persp.description_key,
                    persp.description
                  );
                  return (
                    <div
                      key={persp.name ?? persp.label_key}
                      className="perspective-item gap-3 align-items-start mb-3"
                    >
                      <div className="perspective-label font-semibold">
                        {label}
                      </div>
                      {desc && (
                        <div className="perspective-desc">
                          {desc}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
        </div>
        {/* more preview content here */}
      </div>
      <div className="template-preview-footer">
        <Button
          label={`${t('addTemplate.Create', {
            defaultValue: 'Create',
          })} ${label}`}
          className="Save-button"
        />
        <Button
          label={t('common.actions.close', { defaultValue: 'Close' })}
          className="Close-button mr-2"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default TemplatePreview;
